module.exports = __webpack_public_path__ + "img/ico_shangchengdaijinquan.cad513b2.png";